import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
//System
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import Loader from "@/components/widgets/loader.vue";
import VueCropper from "vue-cropperjs";
Component.registerHooks(["metaInfo"]);
let ImageCropper = /** @class */ (() => {
    let ImageCropper = class ImageCropper extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            //data
            this.title = "Image Cropper";
            this.pageIsLoading = true;
            this.items = [
                {
                    text: "Extras",
                },
                {
                    text: "Image Cropper",
                    active: true
                },
            ];
        }
        data() {
            return {
                imageUrl: require("@/assets/images/users/avatar-2.jpg"),
                cropImg: '',
            };
        }
        // public zoom(percent): void {
        // 	this.$refs.cropper.relativeZoom(percent);
        // }
        // public rotate(deg): void {
        // 	this.$refs.cropper.rotate(deg);
        // }
        // public move(offsetX, offsetY): void {
        // 	this.$refs.cropper.move(offsetX, offsetY);
        // }
        // public flipX(): void {
        // 	const dom = this.$refs.flipX;
        // 	let scale = dom.getAttribute("data-scale");
        // 	scale = scale ? -scale : -1;
        // 	this.$refs.cropper.scaleX(scale);
        // 	dom.setAttribute("data-scale", scale);
        // }
        // public flipY(): void {
        // 	const dom = this.$refs.flipY;
        // 	let scale = dom.getAttribute("data-scale");
        // 	scale = scale ? -scale : -1;
        // 	this.$refs.cropper.scaleY(scale);
        // 	dom.setAttribute("data-scale", scale);
        // }
        // public reset(): void {
        // 	this.$refs.cropper.reset();
        // }
        // public cropImage(): void {
        // 	this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
        // }
        mounted() {
            setTimeout(() => {
                this.pageIsLoading = false;
            }, 100);
        }
    };
    ImageCropper = __decorate([
        Component({
            name: "ImageCropper",
            components: {
                Loader,
                PageHeader,
                Layout,
                VueCropper
            },
        })
    ], ImageCropper);
    return ImageCropper;
})();
export default ImageCropper;
